import React, { useEffect, useState, useRef } from "react";

const TESTIMONIALS = [
  { quote: "Our home’s security is now flawless—Senshoha Door is life-changing.", name: "A. Kumaran", location: "Bangalore, India" },
  { quote: "Saw the pool cover in action—safe, quick, and so smart.", name: "M. Lee", location: "Singapore" },
  { quote: "Smart glass that dims instantly? Senshoha feels like tomorrow.", name: "L. Cavalli", location: "Milan, Italy" }
];

function useStats() {
  const [door, setDoor] = useState(21241);
  const [pool, setPool] = useState(6791);
  useEffect(() => {
    const i1 = setInterval(() => setDoor(d => d + Math.floor(Math.random()*2)), 1800);
    const i2 = setInterval(() => setPool(p => p + Math.floor(Math.random()*1)), 2800);
    return () => { clearInterval(i1); clearInterval(i2); };
  }, []);
  return { door, pool };
}

export default function TestimonialsStats() {
  const [idx, setIdx] = useState(0);
  const timeoutRef = useRef();
  useEffect(() => {
    timeoutRef.current = setTimeout(() => setIdx(i => (i+1)%TESTIMONIALS.length), 3800);
    return () => clearTimeout(timeoutRef.current);
  }, [idx]);

  const { door, pool } = useStats();

  return (
    <section className="bg-gray-900 py-24">
      <div className="max-w-5xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-12">
        {/* Scrolling Testimonials */}
        <div className="md:w-1/2 text-center md:text-left">
          <span className="uppercase tracking-widest text-xs text-gold/50 mb-2 block">Testimonials</span>
          <div className="h-28 flex flex-col items-center justify-center relative">
            {TESTIMONIALS.map((t, i) =>
              <div key={i}
                className={`absolute w-full transition-all duration-700 ease-in-out
                  ${idx === i ? "opacity-100 translate-x-0 z-20" : "opacity-0 -translate-x-10 z-10"}`}>
                <p className="italic text-xl md:text-2xl text-gold/90 mb-1">“{t.quote}”</p>
                <div className="text-sm text-gold/60">{t.name} — {t.location}</div>
              </div>
            )}
          </div>
        </div>
        {/* Live stats */}
        <div className="md:w-1/2 flex flex-col items-center gap-8">
          <div className="flex flex-col bg-brand-gray/90 rounded-xl px-8 py-6 shadow-lg">
            <span className="text-xs uppercase tracking-widest text-gold/60 mb-1">Door Unlocks</span>
            <span className="text-3xl font-mono font-bold text-gold tabular-nums">{door.toLocaleString()}</span>
          </div>
          <div className="flex flex-col bg-brand-gray/90 rounded-xl px-8 py-6 shadow-lg">
            <span className="text-xs uppercase tracking-widest text-gold/60 mb-1">Seconds Saved<br/>by Auto Pool Cover</span>
            <span className="text-3xl font-mono font-bold text-gold tabular-nums">{pool.toLocaleString()}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
